import Skeleton from "@mui/material/Skeleton";
import { Facts } from "../../../../../components/primitives/data-display/Facts";

interface FeedFactsSkeletonProps {
  /** How many rows to draw. */
  rows: number;
}

/** The shape of a list of facts, drawn while it loads: a label on the left, a figure on the right. */
export function FeedFactsSkeleton({ rows }: FeedFactsSkeletonProps) {
  return (
    <Facts
      items={Array.from({ length: rows }, () => ({
        label: <Skeleton width="7em" />,
        value: <Skeleton width="2.5em" sx={{ ml: "auto" }} />,
      }))}
    />
  );
}
